import {
    loadTable,
    load
} from "@/../../cortex/src/services/cortex.js";

import {
    ref
} from "vue"

import check from "@/../../library/helper/propertyCheck";
import {
    fieldStyles
} from "@/../../library/compFunctions/useStyles.js"

import moment from "moment";
const CONSTANTS = require("@/../../library/constants/server.js")

export async function getSchemaTable(table) {
    console.log(`Loading a schema table`)
    let data = await loadTable(table, CONSTANTS.LOGIN);
    console.log(`Schema Data = `, data)
    return data
}

export async function selectProcessing(schema) {
    // Check if this is a list of a table fetch
    let sourceType = schema.en.split(";")[1].split(":")[0]
    console.log(`Schema = `, schema)
    console.log(`Source Type = `, sourceType)
    if(sourceType === "list"){
        let choices = schema.en.split(";")[1].split(":")[1].split(",")
        console.log(`Schema EN = `, schema.en)
        console.log(`MULTI SELECT CHOICES =`, choices)
        return choices
    }
}

export async function translate(schema, data) {
    let fieldList = [];
    for (const entry of schema) {
        if(entry.type === "status") continue
        // Basic setup for the schema object
        let obj = {
            pos: parseInt(entry.pos),
            name: entry.en.split(";")[0],
            type: entry.type,
            ro: entry.hasOwnProperty("ro") && entry.ro === "yes" ? true : false,
            req: entry.hasOwnProperty("req") && entry.req === "yes" ? true : false,
            cols: entry.hasOwnProperty("cols") ? parseInt(entry.cols) : 12,
            data: "",
            key: entry.key
        };
        // Add the choices for the single select list
        if (entry.type === "list") {
            let choices = entry.en.split(";")[1].split(":")[1].split(",");
            obj["choices"] = choices;
        }
        // Add choices for a single / multi select field
        if(entry.type === "multiselect") {
            console.log("^^^^^ MULTI FIELD")
            obj["choices"] = await selectProcessing(entry)
            console.log("Choices = ", obj["choices"])
        }
        // Override the columns if needed
        if (entry.hasOwnProperty("cols") && !check.isEmptyString(entry.cols)) {
            obj["cols"] = entry.cols
        }

        // Add the formattting for the field
        obj["format"] = fieldStyles(obj.type, obj.req, obj.ro)
        fieldList.push(obj);

        // Add Data if it is present
        if (!check.isUndefined(data)) {
            console.log(`DATA IS DEFINED`)
            console.log(`Data = `, data)
            if (data.hasOwnProperty(entry.key)) {
                let value = data[entry.key]
                if (entry.type === "status") value = data[entry.key] === "yes" ? true : false
                if (entry.type === "date") value = moment(value).format("MM-DD-YYYY hh:mm:ss A")
                obj["data"] = value
            }
        }
    }
    let sortedList = fieldList.sort((a, b) => (a.pos > b.pos ? 1 : -1));
    return sortedList
}

export async function schemaFetchandTranslate(args) {
    console.log(`SCHEMA FETCH ARGS: `, args)
    console.log(`SCHEMA:`, args.schema)
    console.log(`ITEM:`, args.item)

    // Get the record data if needed
    let data = undefined
    if (!check.isUndefined(args.item) && !check.isEmptyString(args.item))
        data = await load(args.datatable, args.item, args.dataserver)

    const table = args.schema

    console.log(`8888888888 Data: `, data)
    let rawSchema = await getSchemaTable(table)
    let orderedSchema = await translate(rawSchema, data)
    console.log(`777777777 Ordered Schema: `, orderedSchema)
    return orderedSchema
}

export function schemaDataArray(data) {
    let dataArray = []
    for (const entry of data) {
        let data = null
        if (entry.type === "status") data = entry.data.state
        else data = entry.data
        if (check.isNull(data) || check.isEmptyString(data) || check.isUndefined(data)) continue
        let obj = {
            key: entry.key,
            data: data
        }
        dataArray.push(obj)
    }

    return dataArray
}

export function prepareSavePayload(data, args) {
    let payload = {}
    for (const entry of data) {
        if (check.isBoolean(entry.data)) payload[entry.key] = entry.data ? "yes" : "no"
        else payload[entry.key] = entry.data
    }
    if (!check.isUndefined(args.item) && !check.isEmptyString(args.item))
        payload["_id"] = args.item
    else {
        payload["IsUsed"] = "yes"
    }
    console.log(`PAYLOAD SOURCE -----`, data)
    console.log(`PAYLOAD -------- `, payload)
    return {
        payload
    }
}

export function canSave(data, schema) {
    let required = schema.filter(x => x.req === true).map(x => x.key)

    // Can always save if no required fields
    if (check.isEmptyArray(required)) return true

    // Test that required fields are found
    for (const entry of required) {
        let index = data.findIndex(x => x.key === entry)
        if (index < 0) return false
    }
    return true
}